<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import {mask} from 'vue-the-mask'

export default {
  name: 'UserDetailsInstructorForm',
  props: {
    validation: Object
  },
  directives: {
    mask
  },
  mounted () {
    if(this.isUserWizard && this.affiliateForm.ACTIVE_IND) {
      console.log('affiliateForm', this.affiliateForm)
      this.updateInstructorForm({field: 'INSTRUCTOR_AFFILIATES', value: [{
          AFFILIATE_ID: 'new',
          AFFILIATE_CODE: this.affiliateForm.AFFILIATE_CODE,
          AFFILIATE_NAME: this.affiliateForm.AFFILIATE_NAME
        }]
      })
    }
  },
  data () {
    return {
      selectedAffiliate: ''
    }
  },
  computed: {
    ...mapState('users', {
      userForm: state => state.userForm,
      addressForm: state => state.addressForm,
      affiliateForm: state => state.affiliateForm,
      instructorForm: state => state.instructorForm,
      canEdit: state => state.userModal.canEdit,
      mode: state => state.userModal.mode,
      isUserWizard: state => state.userWizardModal.open,
      activeApprovalStatus:  state => state.activeApproval.STATUS
    }),
    ...mapGetters('users', [
      'affiliateOptions',
      'affiliateIds'
    ]),
    ...mapGetters([
      'stateOptions'
    ]),
    // affiliateIds () {
    //   let affiliates = this.instructorForm.INSTRUCTOR_AFFILIATES
    //   affiliates = affiliates && affiliates.length ? _.map(affiliates,affiliate => affiliate.AFFILIATE_ID) : []
    //   console.log(affiliates)
    //   return affiliates
    // }
  },
  methods: {
    ...mapActions('users', [
      'fetchAffiliates',
      'fetchRecruiters',
      'fetchManagers',
      'fetchAdministrators'
    ]),
    ...mapMutations('users', [
      'updateUserForm',
      'updateAddressForm',
      'updateInstructorForm'
    ]),
    ...mapMutations([
      'closeDetails'
    ]),
    searchAffiliates (terms, done) {
      // return 
    }
  }
}
</script>

<template>
  <div class="q-pb-xl layout-padding">
    <div class="row">
      <h5 class="q-pa-md col-12" style="padding-bottom:0">
        <q-icon color="primary" name="fa fa-graduation-cap"></q-icon> Instructor Information
      </h5>
      <q-field 
        class="q-pa-md col-12"
        error-label="Please add at least one Affiliate!"
        v-if="$p(['ADMIN','MANAGER','RECRUITER'],'or') || isUserWizard"
        :error="validation.instructorForm.INSTRUCTOR_AFFILIATES.$error"
        >
        <q-select
          chips
          multiple
          float-label="Associated Affiliates"
          :value="affiliateIds"
          :options="affiliateOptions"
          filter
          autofocus-filter
          :after="[
            {icon: 'flag', condition: validation.instructorForm.INSTRUCTOR_AFFILIATES.$invalid},
            {icon: 'fa fa-check', condition: !validation.instructorForm.INSTRUCTOR_AFFILIATES.$invalid}
          ]"
          :disable="!canEdit"
          @input="affiliateIds => this.updateInstructorForm({ 
            field: 'INSTRUCTOR_AFFILIATES', 
            value: affiliateIds.map(affiliateId => { 
              return { AFFILIATE_ID: affiliateId }
            })
          })"
        />
      </q-field>
      <q-field class="q-pa-md col-6"
        error-label="Instructor Code is required"
        :error="validation.instructorForm.INSTRUCTOR_CODE.$error"
        :helper="$p(['ADMIN', 'MANAGER'], 'or') ? '' : 'Assigned By Manager'">
        <q-input
          float-label="Instructor Code"
          :value="instructorForm.INSTRUCTOR_CODE"
          :after="[
            {icon: 'flag', condition: validation.instructorForm.INSTRUCTOR_CODE.$invalid},
            {icon: 'fa fa-check', condition: !validation.instructorForm.INSTRUCTOR_CODE.$invalid}
          ]"
          @keyup.stop="updateInstructorForm({ field: 'INSTRUCTOR_CODE', value: $event.target.value })"
          @blur="validation.instructorForm.INSTRUCTOR_CODE.$touch"
          :disable="(!canEdit && mode == 'edit') || !$p(['ADMIN', 'MANAGER'], 'or') || activeApprovalStatus === 'APPROVED'"
          required>
        </q-input>
      </q-field>
      <q-field 
        class="q-pa-md col-6"
        error-label="Drivers License Number is required"
        :error="validation.instructorForm.DRIVERS_LICENSE.$error">
        <q-input
          float-label="Drivers License Number"
          :value="instructorForm.DRIVERS_LICENSE"
          :after="[
            { icon: 'flag', condition: validation.instructorForm.DRIVERS_LICENSE.$invalid, handler () {}},
            {icon: 'fa fa-check', condition: !validation.instructorForm.DRIVERS_LICENSE.$invalid}
          ]"
          @blur="validation.instructorForm.DRIVERS_LICENSE.$touch"
          @keyup.stop="updateInstructorForm({ field: 'DRIVERS_LICENSE', value: $event.target.value })"
          :disable="!canEdit"
          required>
        </q-input>
      </q-field>
      <!-- <q-field class="q-pa-md col-4">
        <q-select
          float-label="Status"
          :value="detailsForm.status"
          :options="statusOptions"
          @change="val => updateInstructorForm({ field: 'status', value: val })"
        />
      </q-field> -->
      <div class="panel" v-if="!$p(['ADMIN','MANAGER'],'or') && (!instructorForm.INSTRUCTOR_ID || instructorForm.ACTIVE_IND) && instructorForm.LK_INSTRUCTOR_STATUS_ID != 1">
        <q-icon name="fa fa-warning" size="30px" /> Your instructor code will be provided to you by your manager. After creating the instructor, they will be sent for Approval.
      </div>
      <div class="panel" v-if="$p(['ADMIN','MANAGER'],'or') && instructorForm.ACTIVE_IND && instructorForm.LK_INSTRUCTOR_STATUS_ID != 1">
        <q-icon name="fa fa-warning" size="30px" /> <span v-if="validation.instructorForm.INSTRUCTOR_CODE.$invalid">Please assign an instructor code.</span> This instructor is pending approval.
      </div>
    </div>
  </div>
</template>

<style lang="stylus">
.exclamation-circle-icon {
  font-size:1.4rem !important
}
.panel
  background #91c6ff
  border-radius 4px
  border 1px solid #68b1ff
  padding 20px
  margin-top 35px
  font-size 14px
  color #2b4765
  display block
  width 100%
</style>
